let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6qBuq")).then(() => parcelRequire('5v8Tc'));